import { createRouter, createWebHistory } from 'vue-router'
import Home from '../Home.vue'
import PostView from '../PostView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/post/:id',
    name: 'PostView',
    component: PostView,
    meta: { 
      metaTags: []
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Gestion dynamique du titre et des meta tags
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Cry4Change'
  
  // Mise à jour des meta tags
  if (to.meta.metaTags) {
    to.meta.metaTags.forEach(tag => {
      const element = document.querySelector(`meta[${tag.name ? 'name' : 'property'}="${tag.name || tag.property}"]`)
      if (element) {
        element.setAttribute('content', tag.content)
      }
    })
  }
  
  next()
})

export default router